module.exports = __webpack_public_path__ + "img/01.91f6efeb.png";